import API from './jsonapi-constants'

export const CONSTANTS = {
  TYPE: 'ordertracking',
  ATTRIBUTE: {
    LINK: 'link',
    ORDER: 'order',
    AMOUNT: 'amount',
    ARTICLE: 'article',
    CARRIER: 'carrier',
    ARTICLE_NOTE: 'articleNote',
    SHIPPING_DATE: 'shippingDate',
    DELIVERY_NOTE: 'deliveryNote',
    SHIPMENT: 'shipment',
  },
}

export const PATHS = {
  LINK: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LINK],
  ORDER: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ORDER],
  AMOUNT: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.AMOUNT],
  ARTICLE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ARTICLE],
  CARRIER: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CARRIER],
  ARTICLE_NOTE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ARTICLE_NOTE],
  SHIPPING_DATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.SHIPPING_DATE],
  DELIVERY_NOTE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.DELIVERY_NOTE],
  SHIPMENT: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.SHIPMENT],
}

export default {
  ...CONSTANTS,
  PATHS,
}
